import {useRef} from 'react';
import {useStore} from 'react-redux';

import {useLatestValue, useOnMount} from 'shared/web';

import {appSyncConnectionApi} from './appSyncConnectionApi';
import type {SubscriptionRootState} from './subscription/subscriptionTypes';

export function useSubscribeToAppSyncReconnect(onReconnect: VoidFunction) {
  appSyncConnectionApi.useGetAppSyncConnectionQuery();
  const store = useStore<SubscriptionRootState>();
  const listener = useLatestValue(onReconnect);
  const cleanup = useRef<VoidFunction>(() => undefined);

  useOnMount(
    () => {
      const selectConnection = appSyncConnectionApi.endpoints.getAppSyncConnection.select();
      let previous = selectConnection(store.getState());
      cleanup.current = store.subscribe(() => {
        const current = selectConnection(store.getState());
        const reconnected =
          current.requestId === previous.requestId &&
          (current.data?.reconnectCount ?? 0) > (previous.data?.reconnectCount ?? 0);
        previous = current;
        if (reconnected) {
          listener.current();
        }
      });
    },
    () => cleanup.current()
  );
}
